import { BottomSheetDialog } from '@medely/web-components';
import useDevice from '@mp/hooks/useDevice.web';
import React from 'react';
import { useResumeBuilderMutations } from '../mutations';
import { Box, Divider, Text, VStack } from '@medely/ui-kit';

type EducationEditModalProps = {
  open: boolean;
  onClose: () => void;
  itemId?: number;
  openEditModal?: () => void;
};

const ModalInfo = ({
  itemId,
  openEditModal,
  onClose,
}: Pick<EducationEditModalProps, 'itemId' | 'openEditModal' | 'onClose'>) => {
  const { deleteEducation } = useResumeBuilderMutations();

  return (
    <VStack>
      <Box
        onClick={() => {
          openEditModal?.();
          onClose();
        }}
        py={1.5}
      >
        <Text size="l">Edit</Text>
      </Box>
      <Divider />
      <Box
        onClick={() => {
          deleteEducation(itemId);
          onClose();
        }}
        py={1.5}
      >
        <Text size="l">Delete</Text>
      </Box>
    </VStack>
  );
};

export const EducationEditModal = ({
  open,
  onClose,
  itemId,
  openEditModal,
}: EducationEditModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      content={<ModalInfo itemId={itemId} openEditModal={openEditModal} onClose={onClose} />}
      isDesktop={isDesktop}
      fullWidth={isDesktop}
      sx={{ top: isDesktop ? 0 : '80%' }}
    />
  );
};
